<template>
  <main>
    <div v-if="errorMessage" class="page-parent">
      User not found.
    </div>
    <div v-else class="page-parent">
      I want to receive e-mails for:
      <label class="email-checkbox">
        <input
          type="checkbox"
          name="invoice"
          :disabled="!hasLoaded"
          :checked="allowedInvoices"
          @change="onInvoiceSettingsChanged"
        />
        Invoices
      </label>
      <label class="email-checkbox">
        <input
          type="checkbox"
          name="marketing"
          :disabled="!hasLoaded"
          :checked="allowedMarketing"
          @change="onMarketingSettingsChanged"
        />
        Marketing
      </label>
    </div>
    <Spinner v-if="!hasLoaded" />
  </main>
</template>

<script>
import Spinner from '../components/shared/Spinner.vue';

export default {
  name: 'Unsubscribe',
  components: {
    Spinner,
  },
  data() {
    return {
      allowedMarketing: false,
      allowedInvoices: false,
      hasLoaded: false,
      errorMessage: undefined,
    };
  },
  mounted() {
    (async () => {
      try {
        const result = await fetch(
          `${process.env.VUE_APP_USER_SERVICE_URL}/user/email-settings?user_uuid=${this.$route.params.uuid}`
        );
        const parsedJson = await result.json();
        this.$data.allowedInvoices = parsedJson.data.invoices;
        this.$data.allowedMarketing = parsedJson.data.marketing;
      } catch {
        this.$data.errorMessage = 'Could not load';
      } finally {
        this.$data.hasLoaded = true;
      }
    })();
  },
  methods: {
    onInvoiceSettingsChanged(event) {
      const shouldSendEmails = event.target.checked;
      this.changeUserEmailSettings(shouldSendEmails, undefined);
    },
    onMarketingSettingsChanged(event) {
      const shouldSendEmails = event.target.checked;
      this.changeUserEmailSettings(undefined, shouldSendEmails);
    },
    async changeUserEmailSettings(invoices, marketing) {
      const formData = new URLSearchParams();
      formData.append('user_uuid', this.$route.params.uuid);
      if (invoices !== undefined) {
        formData.append('invoices', invoices);
      }
      if (marketing !== undefined) {
        formData.append('marketing', marketing);
      }
      try {
        this.$data.hasLoaded = false;
        const result = await fetch(
          `${process.env.VUE_APP_USER_SERVICE_URL}/user/email-settings`,
          {
            method: 'POST',
            type: 'form/json',
            body: formData,
            headers: {
              accept: 'application/json',
              'Content-Type': 'application/x-www-form-urlencoded',
            },
          }
        );
        if (!result.ok) {
          this.$data.errorMessage = 'Something went wrong. Please try again.';
        }
      } catch {
        this.$data.errorMessage = 'Something went wrong. Please try again.';
      } finally {
        this.$data.hasLoaded = true;
      }
    },
  },
};
</script>

<style scoped>
.page-parent {
  padding: 84px 32px 32px 32px;
  font-family: Lato;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.email-checkbox {
  cursor: pointer;
}
</style>
